import { EpicIcons } from "@constellation-academy/epic-ui";
import React from "react";
import { useFragment } from "react-relay";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "@i18n/hooks";
import {
	DISCOUNT_ACTION_FRAGMENT,
	DISCOUNT_CODE_FRAGMENT,
} from "./discount-code-edit-button.graphql";
import { DiscountCodeEditButtonProps } from "./discount-code-edit-button.props";
import { Button } from "../../../../components/button";
import { Paths } from "../../../../routes/paths";

export const DiscountCodeEditButton = ({
	discountActionFragmentRef,
	discountCodeFragmentRef,
}: DiscountCodeEditButtonProps) => {
	const { t } = useTranslation("common");
	const navigate = useNavigate();

	const discountActionResult = useFragment(
		DISCOUNT_ACTION_FRAGMENT,
		discountActionFragmentRef ?? null,
	);
	const discountActionId = discountActionResult?.id ?? null;

	const discountCodeResult = useFragment(DISCOUNT_CODE_FRAGMENT, discountCodeFragmentRef ?? null);
	const codeId = discountCodeResult?.id ?? null;

	const handleOnClick = () => {
		if (!discountActionId || !codeId) {
			return;
		}
		navigate(
			Paths.activeDiscountActions.withId(discountActionId).edit.discountCode.withId(codeId)
				.path,
		);
	};
	return (
		<Button icon={EpicIcons.PENCIL} tooltip={t("actions.editAction")} onClick={handleOnClick} />
	);
};
